import { getApp, getApps, initializeApp } from "firebase/app";
import {
  getAnalytics,
  isSupported,
  Analytics,
  setAnalyticsCollectionEnabled,
} from "firebase/analytics";
import type { FirebaseConfig, SystemConfig } from "@/common/type-state";

let firebaseConfig: FirebaseConfig | null = null;
let initRequested = false;
let analytics: Analytics | null = null;

const hasFirebaseConfig = (config: FirebaseConfig | null): config is FirebaseConfig =>
  !!config &&
  !!config.apiKey &&
  !!config.authDomain &&
  !!config.projectId &&
  !!config.storageBucket &&
  !!config.messagingSenderId &&
  !!config.appId &&
  !!config.measurementId;

const initializeAnalytics = async () => {
  if (analytics || !hasFirebaseConfig(firebaseConfig)) return;

  const supported = await isSupported();

  if (!supported) return;

  const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
  analytics = getAnalytics(app);
  setAnalyticsCollectionEnabled(analytics, true);
};

export const initAnalytics = async () => {
  initRequested = true;
  await initializeAnalytics();
};

export const setConfig = (config: SystemConfig) => {
  firebaseConfig = config.firebase ?? null;

  if (initRequested) {
    void initializeAnalytics();
  }
};

export const getFirebaseAnalytics = () => analytics;
